import { Alert, Container } from "react-bootstrap";
import { t } from "i18next";
const DevEnvAlert = () => {
    if (
        process.env.REACT_APP_API_BASE_URL === "https://dev-seahorse.com/api/"
    ) {
        return (
            <Container className="">
                <Alert dismissible variant="warning">
                    <Alert.Heading>
                        <i className="bi bi-exclamation-triangle-fill text-danger me-3"></i>
                        {t("common:attention")}
                    </Alert.Heading>
                    {t("misc:This_is_Test_env")}
                    <a
                        href="https://memoryclinic.io"
                        target="_blank"
                    >{`https://memoryclinic.io`}</a>{" "}
                    {t("misc:for_real_oprations")}
                </Alert>
            </Container>
        );
    }
    return null;
};

export default DevEnvAlert;
